/**
 * 供应商管理接口
 */
export default {
  // 公用应用-企业资质新增保存
  saveEnterpriseQualif: {
    // mock: true,
    control: 'dyc/saas/supplier/saveEnterpriseQualif'
  },
  // 公用应用-企业资质详情
  qryEnterpriseQualifDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/qryEnterpriseQualifDetail'
  },
  // 公用应用-企业资质修改
  updateEnterpriseQualif: {
    // mock: true,
    control: 'dyc/saas/supplier/updateEnterpriseQualif'
  },
  // 公用应用-企业资质删除
  deleteEnterpriseQualif: {
    // mock: true,
    control: 'dyc/saas/supplier/deleteEnterpriseQualif'
  },
  // 公用应用-企业资质信息列表
  qryEnterpriseQualifListPage: {
    // mock: true,
    control: 'dyc/saas/supplier/qryEnterpriseQualifListPage'
  },
  // 公用应用-流程图
  qryQueryOperationRecordsList: {
    // mock: true,
    control: 'dyc/saas/audit/queryOperationRecordsList'
  },
  // 公用应用-企业资质信息审核列表
  qryEnterpriseQualifAuditListPage: {
    // mock: true,
    control: 'dyc/saas/supplier/qryEnterpriseQualifAuditListPage'
  },
  // 公用应用-供应商企业信息准入列表
  qrySupplierInfoAccessListPage: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupplierInfoAccessListPage'
  },
  // 获取准入token
  loginRenovate: {
    // mock: true,
    control: '/umc/login/loginRenovate'
  },
  // 准入查询
  qrySupplierInfoAccess: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupplierInfoAccess'
  },
  // 公共应用-供应商签约提示
  getSignContractCheck: {
    // mock: true,
    control: 'dyc/saas/common/user/getSignContractCheck'
  },
  // 公用应用-供应商企业信息变更列表
  qrySupplierInfoChangeListPage: {
    // mock: true,
    control: 'dyc/supplier/qrySupplierInfoChangeListPage'
  },
  // 供应商管理-评级管理-供应侧-定级申请-申请详情-合作资质-合作品类表格查询
  sup_gradeItemCat: {
    // mock: true,
    control: 'dyc/saas/supplier/gradeItemCat'
  },
  // 供应商管理-评级管理-供应侧-定级申请-申请详情-合作资质-资质信息表格查询
  sup_queryMappingList: {
    // mock: true,
    control: 'dyc/saas/common/user/queryMappingList'
  },
  // 供应商管理-评级管理-运营侧-等级设置
  sup_queryLevelList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryLevelList'
  },
  // 供应商管理-评级管理-运营侧-等级设置
  sup_getQueryLevelList: {
    control: 'dyc/saas/supplier/queryLevelList'
  },
  // 供应商管理-评级管理-运营侧-等级设置-设置等级
  sup_addLevel: {
    // mock: true,
    control: 'dyc/supplier/addLevel'
  },
  // 供应商管理-评级管理-运营侧-等级设置-设置等级
  sup_postAddLevel: {
    // mock: true,
    control: 'dyc/saas/supplier/addLevel'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置
  // sup_queryList: {
  //   // mock: true,
  //   control: 'dyc/supplier/queryList'
  // },
  sup_queryList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryList'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类查询
  sup_selectList: {
    // mock: true,
    control: 'dyc/saas/supplier/selectList'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类添加
  sup_addScoringIndicators: {
    // mock: true,
    control: 'dyc/supplier/addScoringIndicators'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类添加
  sup_postAddScoringIndicators: {
    control: 'dyc/saas/supplier/addScoringIndicators'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类删除
  sup_deleteScoring: {
    // mock: true,
    control: 'dyc/supplier/deleteScoring'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类删除
  sup_postDeleteScoring: {
    // mock: true,
    control: 'dyc/saas/supplier/deleteScoring'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标分类详情查询
  sup_queryAssessment: {
    // mock: true,
    control: 'dyc/saas/supplier/queryAssessment'
  },
  sup_updateAssessment: {
    // mock: true,
    control: 'dyc/saas/supplier/updateAssessment'
  },
  // 供应商管理-评级管理-运营侧-评级指标设置-指标新增
  sup_addAssessmentRatingIndex: {
    // mock: true,
    control: 'dyc/saas/supplier/addAssessmentRatingIndex'
  },
  // 供应商管理-评级管理-运营侧-评分小组设置
  sup_queryTeamList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryTeamList'
  },
  // 供应商管理-评级管理-运营侧-评分小组设置-新增-详情查询
  sup_queryDetailTeam: {
    // mock: true,
    control: 'dyc/saas/supplier/queryDetailTeam'
  },
  // 供应商管理-评级管理-运营侧-评分小组设置-新增-对应品类下拉
  sup_queryCpCommodityTypeList: {
    // mock: true,
    control: 'dyc/saas/busicommon/commodity/queryCpCommodityTypeList'
  },
  sup_getDycUccCategoryatthefrontdeskQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getDycUccCategoryatthefrontdeskQry'
  },
  // 供应商管理-评级管理-运营侧-评分小组设置-新增
  sup_addScoreTeam: {
    // mock: true,
    control: 'dyc/saas/supplier/addScoreTeam'
  },
  // 供应商管理-供应商名录
  sup_querySupplierDirectories: {
    // mock: true,
    control: 'dyc/saas/supplier/querySupplierDirectories'
  },
  // 供应商管理-评级管理-运营侧-评分小组设置-修改
  sup_updateScoreTeam: {
    // mock: true,
    control: 'dyc/saas/supplier/updateScoreTeam'
  },
  // 供应商管理-评级管理-运营侧-供应商评级结果
  sup_queryRecordList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRecordList'
  },
  // 供应商管理-评级管理-运营侧-供应商评级结果-评级历史
  sup_queryHistoryList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryHistoryList'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置
  sup_queryRatingList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRatingList'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置-修改
  sup_updateRatingRules: {
    // mock: true,
    control: 'dyc/saas/supplier/updateRatingRules'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置-修改-删除
  sup_deleteRatingRules: {
    // mock: true,
    control: 'dyc/supplier/deleteRatingRules'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置-新增
  sup_addRatingRules: {
    // mock: true,
    control: 'dyc/saas/supplier/addRatingRules'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置-修改详情查询
  sup_queryRatingRules: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRatingRules'
  },
  // 供应商管理-评级管理-运营侧-评级规则设置-选择指标-详情查询
  sup_selectByIndexIds: {
    // mock: true,
    control: 'dyc/saas/supplier/selectByIndexIds'
  },
  // 供应商管理-评级管理-运营侧-供应商评分
  sup_queryScoreList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryScoreList'
  },
  // 供应商管理-评级管理-运营侧-供应商评分-评分详情查询
  sup_queryRatingDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRatingDetail'
  },
  // 供应商管理-评级管理-运营侧-供应商评分-评分
  sup_evaluateScore: {
    // mock: true,
    control: 'dyc/saas/supplier/evaluateScore'
  },
  // 供应商管理-评级管理-运营侧-供应商评级
  sup_selectRatingList: {
    // mock: true,
    control: '/dyc/saas/supplier/selectRatingList'
  },
  // 供应商管理-评级管理-运营侧-供应商评级-评级上报
  sup_submitScore: {
    // mock: true,
    control: 'dyc/saas/supplier/submitScore'
  },
  // 供应商管理-评级管理-运营侧-供应商评级-评级-详情查询
  sup_queryDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/queryDetail'
  },
  // 供应商管理-评级管理-运营侧-供应商评级-评级-退回重评
  sup_scoreReBack: {
    // mock: true,
    control: 'dyc/saas/supplier/scoreReBack'
  },
  // 供应商管理-评级管理-供应侧-评级指标设置
  sup_qrySupplierFieldDropDownList: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qrySupplierFieldDropDownList'
  },
  // 供应商管理-评级管理-供应侧-定级申请-申请详情-上传资质API
  sup_addCommodityQualif: {
    // mock: true,
    control: 'dyc/saas/supplier/addCommodityQualif'
  },
  // 供应商管理-评级管理-供应侧-定级申请-待审批-查看审批情况表格查询
  sup_qrySupplierAuditLogList: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupplierAuditLogList'
  },
  // 公用应用-企业供应商定级信息提交审批
  addProduction: {
    // mock: true,
    control: 'dyc/saas/supplier/addProduction'
  },
  // 公用应用-资质品类
  getSignedItemList: {
    // mock: true,
    control: 'dyc/saas/common/user/qrySupSignItemList'
  },
  // 公用应用-企业资质信息审核
  dealEnterpriseQualifAudit: {
    // mock: true,
    control: 'dyc/saas/supplier/dealEnterpriseQualifAudit'
  },
  // 公用应用-企业供应商定级列表查询
  queryAdjustGradeList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryAdjustGradeList'
  },
  // 公用应用-企业供应商定级列表查询
  qrySupplierTemplateDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qrySupplierTemplateDetail'
  },
  // 公用应用-企业供应商定级审核
  auditAdjust: {
    // mock: true,
    control: 'dyc/saas/supplier/auditAdjust'
  },
  // 公用应用-供应商准入提交
  submitSupplierInformationAccess: {
    // mock: true,
    control: 'dyc/supplier/submitSupplierInformationAccess'
  },
  // 采购商-失信行为记录列表查询（专责）
  sup_querySbrBadRecordList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordList'
  },
  // 采购商-供应商信息查询
  sup_listSuppliers: {
    // mock: true,
    control: 'dyc/saas/supplier/listSuppliers'
  },
  // 供应商管理-统计查询-黑名单信息列表查询
  sup_listBlackListMisconduct: {
    // mock: true,
    control: 'dyc/saas/supplier/listBlackListMisconduct'
  },
  // 采购商-失信行为记录申请撤销API（专责）
  sup_repealSbrBadRecordApply: {
    // mock: true,
    control: 'dyc/saas/supplier/repealSbrBadRecordApply'
  },
  // 采购商-失信行为记录新增
  sup_submitSbrBadRecordApply: {
    // mock: true,
    control: 'dyc/saas/supplier/submitSbrBadRecordApply'
  },
  // 采购商-失信行为记录详情查看
  sup_querySbrBadRecordComplaintDetails: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordComplaintDetails'
  },
  // 采购商-失信行为处理提交(运营)
  sup_submitSbrBadRecordComplaint: {
    // mock: true,
    control: 'dyc/saas/supplier/submitSbrBadRecordComplaint'
  },
  // 采购商-失信行为申诉列表查询接口
  sup_querySbrBadRecordComplaintList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordComplaintList'
  },
  // 采购商-黑名单申诉列表查询接口
  sup_qrySupBlackList: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupBlackListAduit'
  },
  // 采购商-黑名单管理（运营）列表查询
  sup_qrySupBlackLists: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupBlackList'
  },
  // 采购商-黑名单解禁
  sup_supBlacklistRevoke: {
    // mock: true,
    control: 'dyc/saas/supplier/supBlacklistRevoke'
  },
  // 采购商-新增黑名单提交
  sup_supBlacklistApply: {
    // mock: true,
    control: 'dyc/saas/supplier/supBlacklistApply'
  },
  // 采购商-黑名单详情查询
  sup_qrySupBlacklistDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupBlacklistDetail'
  },
  // 采购商-失信行为申诉（供应商侧）列表查询
  sup_querySbrSupplierBadRecordList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrSupplierBadRecordList'
  },
  // 采购商-失信行为审批列表查询
  sup_querySbrBadRecordAuditList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordAuditList'
  },
  // 采购商-失信行为审批确认
  sup_auditSbrBadRecord: {
    // mock: true,
    control: 'dyc/saas/supplier/auditSbrBadRecord'
  },
  // 采购商-失信行为审批详情查询
  sup_querySbrBadRecordPunishDetails: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordPunishDetails'
  },
  // 采购商-失信行为申诉审批接口
  sup_replySbrBadRecordComplaint: {
    // mock: true,
    control: 'dyc/saas/supplier/replySbrBadRecordComplaint'
  },
  // 采购商-黑名单审批列表查询接口
  sup_supBlacklistAudit: {
    // mock: true,
    control: 'dyc/saas/supplier/supBlacklistAudit'
  },
  // 采购商-失信行为申诉审批列表查询
  sup_querySbrBadRecordComplaintAduitList: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrBadRecordComplaintAduitList'
  },
  // 采购商-失信行为管理办理-处理通知书
  sup_querySbrNoticeTemplateForDrop: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrNoticeTemplateForDrop'
  },
  // 采购商-失信行为管理办理提交
  sup_confirmSbrBadRecordPunish: {
    // mock: true,
    control: 'dyc/saas/supplier/confirmSbrBadRecordPunish'
  },
  // 供应侧-定级申请-定级申请待审批
  sup_queryProduction: {
    // mock: true,
    control: 'dyc/saas/supplier/queryProduction'
  },
  // 供应侧-定级申请-评级审批
  sup_queryAuditList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryAuditList'
  },
  // 供应侧-定级申请-评级审批-审批
  sup_auditRating: {
    // mock: true,
    control: 'dyc/saas/supplier/auditRating'
  },
  // 黑名单审批-审批流程列表查询
  sup_qryProcessInfoByPage: {
    // mock: true,
    control: 'dyc/saas/supplier/qryProcessInfoByPage'
  },
  // 供应商-失信行为-审批流程节点查询
  sup_qryProcNodeAbility: {
    // mock: true,
    control: 'dyc/saas/supplier/qryProcNodeAbility'
  },
  // 供应商-失信行为-审批流程列表查询
  sup_qrySupMisconductAuditLog: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupMisconductAuditLog'
  },
  // 供应商-整改措施列表查询api
  sup_listRectificationRequire: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/listRectificationRequire'
  },
  // 供应商-整改措施确认列表查询api
  sup_queryIndicatorsList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryIndicatorsList'
  },
  // 供应商-整改要求详情查询api
  sup_selectOneDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/selectOneDetail'
  },
  // 供应商-供应商整改记录查询api
  sup_queryLogs: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/queryLogs'
  },
  // 供应商-供应商整改方案提交api
  sup_submitRectificationPlan: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/submitRectificationPlan'
  },
  // 供应商-供应商整改列表查询api
  sup_qrySupRectificationList: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/qrySupRectificationList'
  },
  // 供应商-整改方案详情查询api
  sup_queryPlanDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/queryPlanDetail'
  },
  // // 供应商-运营商审核整改方案api
  sup_auditRectification: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/auditRectification'
  },
  // 供应商-运营方整改要求提交api
  sup_submitRectificationRequire: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/submitRectificationRequire'
  },
  // 供应商-运营方整改要求提交api
  sup_listTemplates: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/listTemplates'
  },
  // 供应商-供应商确认整改通知api
  sup_confirmRectificationRequire: {
    // mock: true,
    control: 'dyc/saas/supplier/rectification/confirmRectificationRequire'
  },
  // 公用应用-供应商详情
  qrySupplierInformationDetail: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupplierInformationDetail'
  },
  // 公用应用-供应商详情
  submitSupplierInformationChange: {
    // mock: true,
    control: 'dyc/supplier/changeInformation'
  },
  // 公用应用-供应商企业信息调整准入审核API
  suppilierInfoAudit: {
    // mock: true,
    control: 'dyc/supplier/suppilierInfoAudit'
  },
  // 	供应商-通知书模板创建
  cnnc_createSbrNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/createSbrNoticeTemplate'
  },
  // 供应商-通知书模板修改
  cnnc_modifySbrNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/modifySbrNoticeTemplate'
  },
  // 供应商-通知书模板详情查询
  cnnc_querySbrNoticeTemplateDetails: {
    // mock: true,
    control: 'dyc/saas/supplier/querySbrNoticeTemplateDetails'
  },
  // 供应商-通知书模板停用启用
  cnnc_disableOrEnableSbrNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/disableOrEnableSbrNoticeTemplate'
  },
  // 公用应用-供应商模版修改
  cnnc_operSupplierTemplate: {
    // mock: true,
    control: 'dyc/config/cfc/unite/operSupplierTemplate'
  },
  // 供应商-通知书模板列表查询
  cnnc_queryRecNoticeTemplateList: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRecNoticeTemplateList'
  },
  // 供应商-通知书模板修改
  cnnc_modifyRecNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/modifyRecNoticeTemplate'
  },
  // 供应商-通知书模板停用启用
  cnnc_disableOrEnableRecNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/disableOrEnableRecNoticeTemplate'
  },
  // 供应商-通知书模板详情查询
  cnnc_queryRecNoticeTemplateDetails: {
    // mock: true,
    control: 'dyc/saas/supplier/queryRecNoticeTemplateDetails'
  },
  // 供应商整改-通知书模板创建
  cnnc_createRecNoticeTemplate: {
    // mock: true,
    control: 'dyc/saas/supplier/createRecNoticeTemplate'
  },
  // 供应商-店铺审核-通过/驳回
  cnnc_dealOrderAudit: {
    // mock: true,
    control: 'dyc/saas/self/order/dealOrderAudit'
  },
  // 供应商-店铺审核-驳回
  cnnc_dealRuTask: {
    // mock: true,
    control: 'dyc/saas/self/order/dealRuTask'
  },
  // 供应商-店铺审核-转交
  cnnc_dealTransferTask: {
    // mock: true,
    control: 'dyc/saas/self/dealTransferTask'
  },
  // 供应商-店铺审核-前加签
  cnnc_dealJoinSignTask: {
    // mock: true,
    control: 'dyc/saas/self/dealJoinSignTask'
  },
  // // 供应商-店铺审核-传阅
  // cnnc_dealTransferRead: {
  //   // mock: true,
  //   control: 'dyc/saas/self/order/dealTransferRead'
  // }
  // 供应商-店铺审核-传阅(更改接口)
  cnnc_dealTransferRead: {
    // mock: true,
    control: 'dyc/self/order/dealTransferRead'
  },
  // 供应商-店铺审核-传阅(更改接口)
  cnnc_dealUpdateShop: {
    // mock: true,
    control: 'dyc/busicommon/store/updateShop'
  },
  // 低代码接口 供应商准入审批查询
  low_qrySupplierAccessList: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcQrySupplierAccessListService/auto0004/qrySupplierAccessList'
  },
  // 低代码接口 供应商准入-审批-查看审批情况
  low_queryOperationRecordsList: {
    // mock: true,
    control: 'metaData/liandongOrder/dycEacQueryOperationRecordsListService/auto0109/queryOperationRecordsList'
  },
  // 低代码接口 供应商准入-审批-查看审批情况
  low_qryApproveStepList: {
    // mock: true,
    control: 'metaData/liandongOrder/dycQryApproveStepListService/auto0104/qryApproveStepList'
  },
  // 低代码接口 供应商准入-审批-查看审批情况
  low_qryEnterpriseInfoApplyListPage: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcQryEnterpriseInfoApplyListPageService/auto0004/qryEnterpriseInfoApplyListPage'
  },
  // 低代码接口 供应商准入-审批-查看审批情况
  low_qryMemberListPage: {
    // mock: true,
    control: 'metaData/liandongOrder/dycUmcCommonMemberQryListPageService/auto0008/qryMemberListPage'
  },
  // 低代码接口 供应商接入-审批-传阅
  low_dealTransferRead: {
    // mock: true,
    control: 'metaData/liandongOrder/dycTransferReadService/auto0011/dealTransferRead'
  },
  // 低代码接口 供应商接入-审批-驳回
  low_dealOrderAudit0033: {
    // mock: true,
    control: 'metaData/liandongOrder/dycUocOrderAuditService/auto0033/dealOrderAudit'
  },
  // 低代码接口 供应商接入-审批-通过
  low_dealOrderAudit0031: {
    // mock: true,
    control: 'metaData/liandongOrder/dycUocOrderAuditService/auto0031/dealOrderAudit'
  },
  // 低代码接口 查询供应商信息
  low_qryInfoDetail: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcSupplierInfoQryDetailService/auto0017/qryInfoDetail'
  },
  // 低代码接口 查询字典列表
  low_queryCodeList0081: {
    // mock: true,
    control: 'metaData/liandongMember/dycUmcDicDataQueryService/auto0081/queryCodeList'
  },
  low_listTree0002: {
    control: 'metaData/liandongMember/dycUccMdmCatalogListTreeAbilityService/auto0002/listTree'
  },
  // 查询供应商详情
  sup_queryEnterpriseDetail: {
    // mock: true,
    control: 'dyc/supplier/qry/queryEnterpriseDetail'
  },
  // 查询供应商列表 (运营)
  sup_queryEnterprisePageInfo: {
    // mock: true,
    control: 'dyc/supplier/qry/queryEnterprisePageInfo'
  },
  // 更改供应商启禁用状态 (运营)
  sup_updateUmcEnterpriseStatus: {
    // mock: true,
    control: 'dyc/supplier/edit/updateUmcEnterpriseStatus'
  },
  // 供应商管理-新建供应商
  sup_addUmcEnterpriseInfo: {
    // mock: true,
    control: 'dyc/supplier/edit/addUmcEnterpriseInfo'
  },
  // 供应商管理-修改供应商信息
  sup_updateUmcEnterpriseInfo: {
    // mock: true,
    control: 'dyc/supplier/edit/updateUmcEnterpriseInfo'
  },
  // 供应商管理-供应商-我要准入
  sup_submitSupplierInformationAccess: {
    // mock: true,
    control: 'dyc/supplier/edit/submitSupplierInformationAccess'
  },
  // 供应商管理-供应商-准入及信息变更审批
  sup_dealOrderAuditNew: {
    // mock: true,
    control: 'metaData/liandongOrder/dycUocOrderAuditService/auto0001/dealOrderAuditNew'
  },
  // 供应商管理-供应商-新建/修改供应商信息 查询仓库数量
  sup_queryWarehouseCountByCityId: {
    // mock: true,
    control: 'dyc/supplier/qry/queryWarehouseCountByCityId'
  }
};